import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiPhone, FiMail, FiMapPin, FiMessageSquare, FiCalendar } from 'react-icons/fi';
import ContactPopup from './ContactPopup';

const ContactSection = () => {
  const [isContactPopupOpen, setIsContactPopupOpen] = useState(false);

  const openContactForm = (e) => {
    e.preventDefault();
    setIsContactPopupOpen(true);
  };

  const closeContactForm = () => {
    setIsContactPopupOpen(false);
  };

  return (
    <section id="contact-us" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Contact Us!</h2>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-50 rounded-lg p-8 shadow-lg mb-12">
            <p className="text-gray-700 mb-6">
              Have a question? Send us an email. We usually reply in 1-2 business days. If you need to reach us sooner, please call the office at{' '}
              <a href="tel:870-208-4089" className="text-blue-600 font-semibold">
                (870) 208-4089
              </a>
              .<br /><br />
              You can directly email me at{' '}
              <a href="mailto:SimeonSnow@afpadvisor.com" className="text-blue-600 font-semibold">
                SimeonSnow@afpadvisor.com
              </a>{' '}
              for <span className="font-semibold">Wealth Management</span> or at{' '}
              <a href="mailto:snows.tax.financial@gmail.com" className="text-blue-600 font-semibold">
                snows.tax.financial@gmail.com
              </a>{' '}
              for <span className="font-semibold">Tax Services or any other inquiries</span>.
            </p>
            
            {/* Contact Us and Schedule Appointment Buttons */}
            <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8">
              <button
                onClick={openContactForm}
                className="inline-flex items-center bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl font-medium"
              >
                <FiMessageSquare className="mr-2" size={20} />
                Contact Us
              </button>
              <a
                href="https://lunacal.ai/simeon-snow"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-green-600 text-white px-8 py-3 rounded-lg hover:bg-green-700 transition-colors shadow-lg hover:shadow-xl font-medium"
              >
                <FiCalendar className="mr-2" size={20} />
                Schedule Appointment
              </a>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8">
            <div className="w-full md:w-1/2">
              <div className="flex items-start mb-4">
                <FiMapPin className="text-blue-600 mt-1 mr-3 flex-shrink-0" size={20} />
                <div>
                  <p className="font-semibold">Address:</p>
                  <p>144 Linwood Drive Paragould AR 72450</p>
                </div>
              </div>

              <div className="flex items-center mb-4">
                <FiPhone className="text-blue-600 mr-3 flex-shrink-0" size={20} />
                <div>
                  <p className="font-semibold">Phone:</p>
                  <a href="tel:18702084089" className="text-blue-600">
                    (870) 208-4089
                  </a>
                </div>
              </div>

              <div className="flex items-center mb-4">
                <FiMail className="text-blue-600 mr-3 flex-shrink-0" size={20} />
                <div>
                  <p className="font-semibold">Email:</p>
                  <a href="mailto:snows.tax.financial@gmail.com" className="text-blue-600">
                    snows.tax.financial@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-center mb-4">
                <FiMail className="text-blue-600 mr-3 flex-shrink-0" size={20} />
                <div>
                  <p className="font-semibold">Wealth Management:</p>
                  <a href="mailto:SimeonSnow@afpadvisor.com" className="text-blue-600">
                    SimeonSnow@afpadvisor.com
                  </a>
                </div>
              </div>
            </div>

            <div className="w-full md:w-1/2 h-64 md:h-auto">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3255.2857276630023!2d-90.50772548473951!3d36.055481680106894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87d1d04d4e0142df%3A0x8e9acb99d5e3416a!2s144%20Linwood%20Dr%2C%20Paragould%2C%20AR%2072450!5e0!3m2!1sen!2sus!4v1659450000000!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0, borderRadius: "0.5rem", minHeight: "300px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Snow's Tax & Financial Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Popup */}
      <ContactPopup isOpen={isContactPopupOpen} onClose={closeContactForm} />
    </section>
  );
};

export default ContactSection;